import { render, staticRenderFns } from "./TheSiteFooter.vue?vue&type=template&id=42d2ab13&scoped=true&"
import script from "./TheSiteFooter.vue?vue&type=script&lang=js&"
export * from "./TheSiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheSiteFooter.vue?vue&type=style&index=0&id=42d2ab13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d2ab13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Weboldal/weboldal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VFooter,VLayout})
